import React from "react";
import { OverlayTrigger } from "react-bootstrap";
import purpleCrossIcon from "assets/icon/purple-cross-icon.svg";
import iconStatus from "assets/icon/status-save-icon.svg";
import { useState } from "react";
const currentStep = 4;
const numSteps = 9;
const VerticalStatusPopover = ({row}) => {
const{patient, patientName,status}=row
  // console.log(row)
  // debugger
  // const initialIcons = {};
  // initialIcons[row.id] =
  //   row.status === purpleCrossIcon ? purpleCrossIcon : iconStatus;

  // const [icons, setIcons] = useState(initialIcons);

  // const handleClick = (rowId) => {
  //   setIcons((prevIcons) => ({
  //     ...prevIcons,
  //     [rowId]:
  //       prevIcons[rowId] === purpleCrossIcon ? iconStatus : purpleCrossIcon,
  //   }));
  // };
  const [show, setShow] = useState(false)
  
  const ontoggle =() =>{
    setShow(prev => !prev)
  }

  return (
    <div className="d-flex gap-2">
      <div>
        {/* {hiddenManufacturers.length > 0 && ( */}
        <OverlayTrigger
          trigger="click"
          placement="bottom"
          key={row}
          fallbackPlacements={["top"]}
          // rootClose
          flip={true}
          popperConfig={{
            modifiers: [
              {
                name: "flip",
                options: {
                  fallbackPlacements: ["top", "bottom"],
                },
              },

              {
                name: "preventOverflow",
                options: {
                  boundariesElement: "viewport",
                },
              },
            ],
          }}
          overlay={
            <div
              id="manufacturers-tooltip"
              style={{ zIndex: 99, marginLeft: "63px", marginTop: "17px" }}
            >
              <div className="popup-status-vertical">
                <div
                  className="stepper-vertical"
                  id="stepper1"
                  portalId="root portal"
                
                >
                  {Array.from({ length: numSteps }, (_, index) => {
                    const stepNum = index + 1,
                      stepTitles = [
                        patient||patientName,
                        "E-Rx",
                        "Order Entry",
                        status,
                        "Claim Details",
                        "Initial Review",
                        "Packaging",
                        "Final Review",
                        "Sales",
                      ],
                      isCurrent = stepNum === currentStep,
                      isDone = stepNum < currentStep;
                    return (
                      <div
                        className={`step-vertical ${
                          isCurrent ? "editing fffff" : ""
                        } ${isDone ? "done" : ""}`}
                        key={stepNum}
                      >
                        <div className="step-circle-vertical">
                          <span>{stepNum}</span>
                        </div>
                        <div>
                          <div className="step-title-vertical">
                            {stepTitles[stepNum - 1]}
                          </div>
                          <div className="step-desc-vertical">
                            <div className="step-time-vertical">13:21,</div>
                            <div className="step-time-vertical">02/06/2025</div>
                          </div>
                        </div>
                        <div className="step-bar-left-vertical"></div>
                        <div className="step-bar-right-vertical"></div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          }
        >
          <div  className="statusIcon">
          {/* <span onClick={() => handleClick(row.id)} style={{cursor:"pointer"}}>
           <span className="statusIcon"><img src={icons[row.id]} alt="status icon"  /> </span>
          </span> */}
          {row.status== [] ? '':
          <img  src = {show ? purpleCrossIcon: iconStatus} alt={show ? "icon": "cancel"} onClick={ontoggle}/>}
         
          </div>
        </OverlayTrigger>
        {/* )} */}
      </div>
      <div> {row.status}</div>
     
    </div>
  );
};

export default VerticalStatusPopover;
